const sensitiveCharacterEditFieldKeys = [
    "name",
    "title",
    "persona",
    "greeting",
    "dialogue",
    "scenario",
    "visibility",
    "avatar_url",
];
const haveSensitiveFieldsChanged = ({ currentValues, initialValues, }) => {
    return sensitiveCharacterEditFieldKeys.some((field) => {
        const currentValue = currentValues[field];
        const initialValue = initialValues[field];
        if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
            return JSON.stringify(currentValue) !== JSON.stringify(initialValue);
        }
        return currentValue !== initialValue;
    });
};
const checkShouldBypassModerationReview = ({ isEdit, isPublic, hasUpdateModerationFlag, submitForManualReview, currentValues, initialValues, }) => {
    if (!isEdit || !isPublic || !hasUpdateModerationFlag || submitForManualReview) {
        return false;
    }
    return !haveSensitiveFieldsChanged({ currentValues, initialValues });
};
export default checkShouldBypassModerationReview;
